import React from 'react';
import classNames from 'classnames';
import { Stack, Shimmer } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getShimmerStyles } from './styles/get-shimmer-styles';

export const BudgetShimmer = () => {
  const classes = useDefaultStyles(getShimmerStyles);

  return (
    <div className={classNames(classes.shimmerContainer, 'budget-shimmer')}>
      <Stack tokens={{ childrenGap: 16 }}>
        <Shimmer />
        <Shimmer width="75%" />
        <Shimmer width="50%" />
      </Stack>
    </div>);
};
